import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import {requestGetInviteJobMailTemps} from "@app/services/InviteJobMailTemplateService";
import {MailTempType} from "@pages/email/common/Constant";
import SelectDVTJCUVMailTemplateContent from "@pages/dvtjcuv/rundvtjcuv/SelectDVTJCUVMailTemplateContent";
import {EmailInviteMode} from "@pages/candidate/list/DVTJCUVEmailInviteModal";

const SelectDVTJCUVMailTemplateModal = (props) => {
    const [tempOptions, setTempOptions] = useState([]);
    const [selectTemplate, setSelectTemplate] = useState([]);

    const {isShow, onConfirm, onClose} = props

    const fetchDVTJCUVMailTemplates = async () => {
        const res = await requestGetInviteJobMailTemps({search_conditions: {unlimited: true, template_type: MailTempType.DVTJCUV_INVITE_EMAIL}});
        const signatureList = res.content.mail_templates
        const tempOptionList = []
        signatureList.forEach(item => {
            tempOptionList.push({value: item.id, label: item.name, content: item.signature_body})
        })
        setTempOptions([...tempOptionList]);
    }

    const onSelectTemplate = (tempOption) => {
        setSelectTemplate(tempOption)
    }

    useEffect(() => {
        // const strUserLogin = localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)
        // if (!userLoginInfo.id && strUserLogin) {
        //     const userLogin = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
        //     setUserLoginInfo(userLogin)
        //
        //     fetchDVTJCUVMailTemplates()
        // }
        // Chỉ get template của user đang login (đã xử lý phía BE)
        fetchDVTJCUVMailTemplates().then()
    },[]);

    return (
        <>
            <Modal show={isShow}
                   size={"lg"}
                   onHide={() => onClose()}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>
                        {'Chọn DVTJCUV mail template'}
                    </Modal.Title>
                    <Button variant='secondary' onClick={() => onClose()}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <div className={"row"}>
                        <div className='col-sm-6'>
                            <SelectDVTJCUVMailTemplateContent
                                tempType={MailTempType.DVTJCUV_INVITE_EMAIL}
                                onSelect={values => {
                                onSelectTemplate(values)
                            }}/>
                        </div>
                        <div className={'mt-4'}>
                            <button
                                type='button'
                                className='btn btn-primary mt-2'
                                onClick={() => onConfirm(selectTemplate.value)}
                                disabled={!selectTemplate.value}
                            >
                                {"Chọn template"}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default SelectDVTJCUVMailTemplateModal;
